
    import {TipsPart} from '@/profile-creation-wizard/components/for-creation/TipsPart';
    import {Options, Vue} from 'vue-property-decorator';
    import BottomSheetDisplayer from '@/common/ui/BottomSheetDisplayer';
    import {eventBusProfileCreationWizard} from '@/profile-creation-wizard/common/events';
    import {getTipsClassPosition} from '@/common/ui/GetTipsClassPosition';

    @Options({})
    export default class LocalisationSide extends Vue {
        tipsPart: TipsPart | null = null; // with null, tipsPart is a reactive value
        tipsClassPosition = getTipsClassPosition(85);

        created(): void {
            this.tipsPart = this.defaultTips;
            this.bottomSheetDisplayer = new BottomSheetDisplayer('', this.$el, 'div.profile-creation-wizard');
            eventBusProfileCreationWizard.on('creation:focus-changed', this.listenFocus);
        }

        beforeUnmount(): void {
            eventBusProfileCreationWizard.off('creation:focus-changed', this.listenFocus);
        }

        listenFocus(tipsPart: TipsPart): void {
            if (tipsPart === TipsPart.locationAndWorkplace) {
                this.tipsClassPosition = getTipsClassPosition(85);
            } else if (tipsPart === TipsPart.phone) {
                this.tipsClassPosition = getTipsClassPosition(770);
            } else {
                this.tipsClassPosition = getTipsClassPosition(425);
            }
            this.tipsPart = tipsPart;
        }

        get isPhoneFocus(): boolean {
            return this.tipsPart === TipsPart.phone;
        }

        get defaultTips(): TipsPart {
            return TipsPart.locationAndWorkplace;
        }

        get isLocationFocus(): boolean {
            return this.tipsPart === TipsPart.locationAndWorkplace;
        }

        get isLanguagesFocus(): boolean {
            return this.tipsPart === TipsPart.languages;
        }
        get locationWording(): any {
            const isFunnelStrategy = this.$store.state.isFunnelStrategy;

            return {
                title: this.$msg(`profile.creation.completion.wizard.v2.side.details.location.${isFunnelStrategy ? 'strategy.' : ''}title`),
                subtitle: this.$msg(`profile.creation.completion.wizard.v2.side.details.location.${isFunnelStrategy ? 'strategy.' : ''}subtitle`),
            };
        }
    }
